// eslint-disable-next-line no-unused-vars
import { StaticDataTypes } from "../Util/Enumerators/staticDataTypes";
import useStaticData from "./useStaticData";

const useStaticDataCustom = (optionsToLoad: StaticDataTypes[]) => useStaticData(optionsToLoad);
export default useStaticDataCustom;
